$(() => {
    $("[data-project-gallery]").each(function () {
        if (typeof $.fn.lightGallery !== "function") return;
        $(this).lightGallery({
            selector: ".pj-gallery-link",
            download: false,
            thumbnail: false,
            getCaptionFromTitleOrAlt: false,
        });
    });
});
